import { render, staticRenderFns } from "./Tanya.vue?vue&type=template&id=1ad87cd7&scoped=true"
import script from "./Tanya.vue?vue&type=script&lang=js"
export * from "./Tanya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad87cd7",
  null
  
)

export default component.exports